// seo.config.js
export const siteConfig = {
    siteName: "QuickTor מערכת לניהול תורים ותזכורות",
    defaultLocale: "he_IL",
    baseUrl: "https://quicktor.co.il",
    verifications: {
      google: "DvOcV86mkYD-XXMIIUz4hgVXQqRl3lzazqQ1IgqDdgE",
      facebook: "7mdup0iqy13ng89l4imdtl241i9o4s",
    }
  };